









import { getCurrentUser } from '@ultraware/vue-user-management'
import CreateArticleWrapper from 'src/components/CreateArticleWrapper.vue'
import { IUser } from 'src/laura-types'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
@Component({
  components: { CreateArticleWrapper },
})
export default class CreateArticle extends Vue {
  @Getter(getCurrentUser) public user!: IUser

  get publisherName(): string {
    return this.user.publisher ? this.user.publisher.name : ''
  }
}
